module.exports = __webpack_public_path__ + "static/media/homenouser.32822ba5.png";